import React from 'react';
import {
    PopupContainer,
    TextAreaContainer,
    TextArea,
    StyledDiv,
    ButtonsContainer,
} from '../QuickOrderCommon.styled'; //style in common
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';

/**
 * Common bulk add popup for quick order/product lists.
 * @param {Object} props
 * @param {boolean} props.show - Whether to show the popup
 * @param {function} props.onClose - Function to close the popup
 * @param {string} props.textValue - Value of the textarea
 * @param {function} props.setTextValue - Function to update textarea value
 * @param {string} props.placeholder - Placeholder for textarea
 * @param {string} props.title - Popup title
 * @param {function} props.onAdd - Function to add items
 * @param {function} props.onPaste - Function to paste from clipboard
 * @param {function} props.onClear - Function to clear textarea
 * @param {string} props.linesLabel - Label for lines count
 * @param {string} [props.editableHeight] - Optional height for textarea
 */
const QuickOrderBulkAddPopup = ({
    show,
    onClose,
    textValue,
    setTextValue,
    placeholder,
    title,
    onAdd,
    onPaste,
    linesLabel,
    editableHeight,
    showBulkAdd,
    setShowBulkAdd,
    setBulkValues,
    bulkValues,
    t,
    resetPosition,
    id,
    landscapeMarginTop,
    mbPaddingTop,
    mbTextAreaHeight,
    mobileHeight,
    smlMarginBottom
}) =>
    show ? (
        <Popup
            borderRadius={'6px'}
            landscapeHeight={'250px'}
            landscapeMarginTop={landscapeMarginTop ? landscapeMarginTop : '200px'}
            landscapeMarginBottom={'180px'}
            ipadwidth={'609px'}
            title={title}
            onClick={() => setShowBulkAdd(!showBulkAdd)}
            overflow={'hidden'}
            quickOrderAddProducts
            id={'common-quickOrderBulkAddPopup-AddButton-popup'}
            mbPaddingTop={mbPaddingTop}
        >
            <PopupContainer
                height={editableHeight ? 'calc(452px - 100px)' : ''}
                mobileHeight={mobileHeight ? mobileHeight : ''}
            >
                {' '}
                <TextAreaContainer>
                    <TextArea
                    id = 'quick-order-bulk-add-textarea'
                        landscapeHeight={'85px'}
                        landscapeMarginLeft={'-20px'}
                        height={editableHeight}
                        value={textValue}
                        onChange={(e) => setBulkValues(e.target.value)}
                        placeholder={placeholder}
                        mbTextAreaHeight={mbTextAreaHeight}
                    />
                </TextAreaContainer>
                <StyledDiv>
                    {`${
                        bulkValues
                            .split('\n')
                            .map((element) =>
                                element.replace(/[\r\n]+/gm, '').trim()
                            )
                            ?.filter((item) => item.length > 0).length
                    }` >= 1 && (
                        <p
                            style={{
                                fontSize: '14px',
                                color: '#000000',
                                margin: '0',
                                fontFamily: 'AvenirNextWorld Regular',
                                opacity: '1',
                            }}
                        >
                            {`${
                                bulkValues
                                    .split('\n')
                                    .map((element) =>
                                        element.replace(/[\r\n]+/gm, '').trim()
                                    )
                                    ?.filter((item) => item.length > 0).length
                            } ${t('scheduleSurgery.details.lines')}`}
                        </p>
                    )}
                </StyledDiv>
                <ButtonsContainer smlMarginBottom={smlMarginBottom}>
                    <Button
                    id={'common-quickOrderBulkAddPopup-CloseButton'}
                        show
                        //secondary
                        variant={ButtonStyles?.secondary}
                        width={'95px'}
                        height={'38px'}
                        margin={'0px 9px 0px 0px'}
                        clicked={onPaste}
                        fontSize={'14px'}
                    >
                        {t('scheduleSurgery.quickOrder.paste')}
                    </Button>
                    <Button
                    id={'common-quickOrderBulkAddPopup-ClearButton'}
                        show
                        //secondary
                        variant={ButtonStyles?.secondary}
                        width={'84px'}
                        height={'38px'}
                        margin={'0px 9px 0px 0px'}
                        clicked={() => {
                            setBulkValues('');
                            resetPosition();
                        }}
                        fontSize={'14px'}
                    >
                        {t('common.clearButton')}
                    </Button>
                    <Button
                    id={'common-quickOrderBulkAddPopup-AddButton'}
                        show
                        disabled={textValue.length < 1}
                        // primary={textValue.length > 0}
                        variant={textValue.length > 0 ? ButtonStyles?.primary : ButtonStyles?.disabled}
                        width={'120px'}
                        height={'38px'}
                        margin={'0px 0px 0px 0px'}
                        clicked={onAdd}
                        fontSize={'14px'}
                    >
                        {t('scheduleSurgery.quickOrder.addTolistText')}
                    </Button>
                </ButtonsContainer>
            </PopupContainer>
        </Popup>
    ) : null;

export default QuickOrderBulkAddPopup;
